import React from 'react';
import { styled } from '@compiled/react';
import Link from '@atlaskit/link';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import illustration from './assets/empty-icon.svg';
import messages from './messages.tsx';

export const EmptyState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const learnMoreLabelMessage = fg('jira-issue-terminology-update-m4')
		? messages.learnMoreLabelIssueTerminologyRefreshM4
		: messages.learnMoreLabel;

	return (
		<Container>
			<img src={illustration} width={80} alt="" />
			<section>
				<Heading as="h3" size="xsmall">
					{formatMessage(messages.title)}
				</Heading>
				<Description>{formatMessage(messages.desciption)}</Description>
				<Link
					href="https://support.atlassian.com/jira-cloud-administration/docs/integrate-figma-with-jira/"
					target="_blank"
				>
					{formatMessage(learnMoreLabelMessage)}
				</Link>
			</section>
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	alignItems: 'center',
	columnGap: token('space.300'),
	marginTop: token('space.200'),
	paddingTop: token('space.300'),
	paddingRight: token('space.300'),
	paddingBottom: token('space.300'),
	paddingLeft: token('space.300'),
	borderRadius: token('radius.large'),
	borderWidth: token('border.width.selected'),
	borderStyle: 'dashed',

	borderColor: `${token('color.border')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.p({
	color: token('color.text.subtlest'),
});
